import React, { Component } from "react";

import { Card, CardBody } from "reactstrap";
import { connect } from "react-redux";

import { Link } from "react-router-dom";
import { formValueSelector } from "redux-form";

import moment from "moment";
import { Tooltip } from "../../../core";
import PlaylistHeader from "./playlistHeader";
import { CardImageWithLoad } from "../../../helper/cardImageWithLoad";
import { CustomCheckBox } from "../../../helper/customCheckBox";
import VerifyLockedPlaylist from "../../../helper/verifyLockedPlaylist";

import RouteAllowed from "../../../helper/isRouteAllowed";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

class PlaylistGrid extends Component {
  render() {
    const { roles, permission } = this.props;
    return (
      <div>
        <PlaylistHeader
          forwardRef={this.props.searchRef}
          refreshing={this.props.refreshing}
          handleRefresh={this.props.handleRefresh}
          handleStatusFilter={this.props.handleStatusFilter}
          handleFilter={this.props.handleFilter}
          handleSearch={this.props.handleSearch}
          handleFilterWithType={this.props.handleFilterWithType}
          handleArchiveItems={this.props.handleArchiveItems}
          disableArchiveIcon={this.props.disableArchiveIcon}
          handleDeletePlaylists={this.props.handleDeletePlaylists}
          playlistSelected={this.props.playlistSelected}
          change={this.props.ReduxFormChange}
          // below needed for col visibility toggler
          {...this.props}
        />
        <div className="screenShot_container">
          <div className="row">
            {this.props.playlistList.length ? (
              this.props.playlistList.map(playlist => (
                <div
                  className="col-xs-12 col-sm-8 col-md-6 col-lg-3"
                  key={playlist.id}
                >
                  <Card className="screenShot_container__screen">
                    <CardBody>
                      <div className="screenShot_container__imageWrapper">
                        <Link
                          to={{
                            pathname: `/playlist/edit/${playlist.id}/`,
                            state: { name: playlist.attributes.name }
                          }}
                          className={`contentSectionTable__actionButtonWrapper__buttons ${!roles.includes(
                            "SuperAdmin"
                          ) &&
                            playlist.attributes.locked &&
                            "verified-playlist-link-disable"}`}
                          onClick={e => e.stopPropagation()}
                        >
                          <div>
                            <CardImageWithLoad
                              url={
                                playlist.attributes.playlist_thumbnail_large_url
                              }
                            />
                          </div>
                          <PhoneBreakpoint>
                            <VerifyLockedPlaylist
                              roles={roles && roles}
                              permission={permission && permission}
                              row={playlist}
                            >
                              <CustomCheckBox
                                item={playlist}
                                selectedList={this.props.playlistSelected}
                                form="SelectedPlaylists"
                                formField="playlistSelected"
                                change={this.props.ReduxFormChange}
                              />
                            </VerifyLockedPlaylist>
                          </PhoneBreakpoint>
                          <div
                            className="imageOverlay imageOverlay--mod"
                            style={{
                              bottom:
                                this.props.playlistSelected.filter(
                                  i => i.id === playlist.id
                                ).length > 0 && 0
                            }}
                          >
                            <VerifyLockedPlaylist
                              roles={roles && roles}
                              permission={permission && permission}
                              row={playlist}
                            >
                              <CustomCheckBox
                                item={playlist}
                                selectedList={this.props.playlistSelected}
                                form="SelectedPlaylists"
                                formField="playlistSelected"
                                change={this.props.ReduxFormChange}
                              />
                            </VerifyLockedPlaylist>

                            <div className="actionButtonWrapper actionButtonWrapper--mod">
                              <RouteAllowed
                                roles={roles && roles}
                                permission={
                                  permission && permission.playlist.dublicate
                                }
                              >
                                <VerifyLockedPlaylist
                                  roles={roles && roles}
                                  permission={permission && permission}
                                  row={playlist}
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        role="presentation"
                                        className="fa fa-clone action__clone"
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          this.props.handleDuplicate(
                                            playlist.id
                                          );
                                        }}
                                      />
                                    }
                                    id={`clone-playlist-${playlist.id}`}
                                    tooltipContent="Duplicate"
                                  />
                                </VerifyLockedPlaylist>
                              </RouteAllowed>
                              <RouteAllowed
                                roles={roles && roles}
                                permission={
                                  permission && permission.playlist.delete
                                }
                              >
                                <VerifyLockedPlaylist
                                  roles={roles && roles}
                                  permission={permission && permission}
                                  row={playlist}
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        role="presentation"
                                        className="fa fa-trash"
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          this.props.handleDelete(
                                            playlist.id,
                                            playlist.attributes.name
                                          );
                                        }}
                                      />
                                    }
                                    id={`delete-${playlist.id}`}
                                    tooltipContent="Delete"
                                  />
                                </VerifyLockedPlaylist>
                              </RouteAllowed>

                              {playlist.attributes.locked ? (
                                <RouteAllowed
                                  roles={roles && roles}
                                  permission={
                                    permission && permission.playlist.lock
                                  }
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        role="presentation"
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          return this.props.handleLockUnLockPlaylist(
                                            playlist.id,
                                            playlist.attributes.name,
                                            "unlock",
                                            false
                                          );
                                        }}
                                        className="fas fa-lock-open action__trash"
                                        style={{ cursor: "pointer" }}
                                      />
                                    }
                                    id={`unlock-${playlist.id}`}
                                    tooltipContent="UnLock Playlist"
                                  />
                                </RouteAllowed>
                              ) : (
                                <RouteAllowed
                                  roles={roles && roles}
                                  permission={
                                    permission && permission.playlist.lock
                                  }
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        role="presentation"
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          return this.props.handleLockUnLockPlaylist(
                                            playlist.id,
                                            playlist.attributes.name,
                                            "lock",
                                            true
                                          );
                                        }}
                                        className="fas fa-lock action__trash "
                                        style={{ cursor: "pointer" }}
                                      />
                                    }
                                    id={`lock-${playlist.id}`}
                                    tooltipContent="Lock Playlist"
                                  />
                                </RouteAllowed>
                              )}
                              <RouteAllowed
                                roles={roles && roles}
                                permission={
                                  permission && permission.archive.playlist
                                }
                              >
                                <VerifyLockedPlaylist
                                  roles={roles && roles}
                                  permission={permission && permission}
                                  row={playlist}
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        role="presentation"
                                        className="fa fa-archive"
                                        onClick={e => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          return this.props.handleArchiveItem(
                                            playlist.id,
                                            playlist.attributes.name
                                          );
                                        }}
                                      />
                                    }
                                    id={`archive-${playlist.id}`}
                                    tooltipContent="Archive"
                                  />
                                </VerifyLockedPlaylist>
                              </RouteAllowed>
                            </div>
                            <RouteAllowed
                              roles={roles && roles}
                              permission={
                                permission && permission.playlist.edit
                              }
                            >
                              <VerifyLockedPlaylist
                                roles={roles && roles}
                                permission={permission && permission}
                                row={playlist}
                              >
                                <div className="centerAlignedDiv">
                                  <span>Edit Playlist</span>
                                </div>
                              </VerifyLockedPlaylist>
                            </RouteAllowed>
                            {!roles.includes("SuperAdmin") &&
                              playlist.attributes.locked && (
                                <div className="centerAlignedDiv centerAlignedDiv--locked">
                                  <span>Locked Playlist</span>
                                </div>
                              )}
                          </div>
                        </Link>
                      </div>
                      <div className="d-flex screenShot_container__textWrapper">
                        <div className="mr-auto screenShot_container__hostName">
                          {playlist.attributes.name &&
                          playlist.attributes.name.length >= 20 ? (
                            <Tooltip
                              item={
                                <span>
                                  {" "}
                                  {`${playlist.attributes.name.slice(
                                    0,
                                    20
                                  )}...`}{" "}
                                </span>
                              }
                              id={`viewname-${playlist.id}`}
                              tooltipContent={playlist.attributes.name}
                            />
                          ) : (
                            <span>{playlist.attributes.name}</span>
                          )}
                          {!playlist.attributes.name && <span>N/A</span>}
                        </div>
                      </div>

                      <span style={{ fontSize: "14px" }}>
                        {playlist.attributes.updated_at
                          ? `  Updated ${moment
                              .utc(playlist.attributes.updated_at)
                              .fromNow()}`
                          : "N/A"}{" "}
                      </span>
                    </CardBody>
                  </Card>
                </div>
              ))
            ) : (
              <span className="null-message-info">No Data</span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector("SelectedPlaylists");
  return {
    playlistSelected: selector(state, "playlistSelected") || []
  };
}
export default connect(mapStateToProps)(PlaylistGrid);
